module.exports = {
  1: '0x8Bf384296A009723435aD5E8203DA5736b895038',
  17000: '0x8Bf384296A009723435aD5E8203DA5736b895038',
  11155111: '0x8Bf384296A009723435aD5E8203DA5736b895038',
}
